import { ModalFooter, Button } from '@chakra-ui/react';

interface FooterControlsProps<T> {
  applyValue?: T;
  onApply(value?: T): void;
}
const FooterControls = <T extends any>({
  applyValue,
  onApply,
}: FooterControlsProps<T>) => {
  return (
    <ModalFooter>
      <Button rounded="xl" size="sm" padding="2px 15px">
        Cancel
      </Button>
      <Button
        colorScheme="green"
        ml="2"
        rounded="xl"
        size="sm"
        padding="2px 15px"
        onClick={() => onApply(applyValue)}
      >
        Apply
      </Button>
    </ModalFooter>
  );
};

export default FooterControls;
